import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Founder = () => (
  <section id="founder" data-testid="founder-section" className="border-t border-brand-border py-28 lg:py-40">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-6 lg:grid-cols-12 lg:px-12">
      <motion.div
        initial={{ opacity: 0, y: 48 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 1, ease: EASE }}
        className="lg:col-span-5"
      >
        <div className="arch-frame mx-auto max-w-sm border border-brand-border p-3">
          <div className="arch-frame overflow-hidden">
            <img
              src="/assets/founder-final.jpg"
              alt="Jagriti Mehta, founder of Laxwedeepan, in a white cotton garment"
              data-testid="founder-image"
              loading="lazy"
              className="aspect-[4/5] w-full object-cover"
            />
          </div>
        </div>
        <p className="mt-8 text-center text-[10px] uppercase tracking-[0.35em] text-brand-ink/50">
          Jagriti Mehta · Founder
        </p>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 48 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 1, delay: 0.15, ease: EASE }}
        className="lg:col-span-7"
      >
        <p className="text-[11px] font-medium uppercase tracking-[0.4em] text-brand-gold">A note from our founder</p>
        <blockquote className="mt-10 font-display text-3xl font-medium leading-snug text-brand-ink md:text-5xl" data-testid="founder-quote">
          “Pure in Spirit. <em className="italic text-brand-purple">Sacred in Purpose.</em>”
        </blockquote>
        <p className="mt-10 max-w-xl text-base font-light leading-relaxed text-brand-ink/70">
          Laxwedeepan was never a business plan. It grew from my own space of peace
          and contentment — from a love for things organic, handcrafted and true.
          From the ghee that feeds your diya to the clay toy in your child's hand,
          everything we make carries one intention: that the sacred stays sacred.
          This is our poojan dharm, and it is my promise to your home.
        </p>
        <p className="mt-10 font-display text-2xl italic text-brand-maroon">— Jagriti Mehta</p>
      </motion.div>
    </div>
  </section>
);
